import { type ActionThunk, createStore, type Store } from 'react-sweet-state';

import {
	CHAT_STORE_STATUS,
	DEFAULT_CONVERSATION_PAGINATION,
	type ChatStorePrivateState,
} from './types';

export const EMPTY_CONVERSATION_ID = 'EMPTY_CONVERSATION_ID';

export const createInitialChatState = (): ChatStorePrivateState => ({
	conversations: {
		EMPTY_CONVERSATION_ID: {
			id: EMPTY_CONVERSATION_ID,
			messages: [],
			name: '',
			status: CHAT_STORE_STATUS.idle,
			traces: [],
			timeCreated: new Date().toISOString(),
		},
	},
	currentConversationId: EMPTY_CONVERSATION_ID,
	isConversationsInitialized: false,
	conversationPagination: { ...DEFAULT_CONVERSATION_PAGINATION },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let store: Store<ChatStorePrivateState, any>;

export const createChatStore = <T extends Record<string, ActionThunk<ChatStorePrivateState, T>>>(
	actions: T,
): Store<ChatStorePrivateState, T> => {
	if (!store) {
		store = createStore({
			name: 'ConversationAssistantStore',
			initialState: createInitialChatState(),
			actions,
		});
	}

	// The module-level `store` is typed as `any` because its action type T is
	// not known at declaration time. The cast here is safe: `createChatStore` is
	// always called with the same concrete actions object.
	return store as Store<ChatStorePrivateState, T>;
};
